import { render } from "./help-view-component.vue?vue&type=template&id=63e40512&scoped=true&ts=true"
import script from "./help-view-component.vue?vue&type=script&lang=ts&scoped=true"
export * from "./help-view-component.vue?vue&type=script&lang=ts&scoped=true"

import "./help-view-component.vue?vue&type=style&index=0&id=63e40512&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e40512"]])

export default __exports__